import { useVariant } from "../context/VariantContext";

export default function Life() {
  const { life } = useVariant();
  return (
    <section className="lp__life" id="life">
      <p className="lp__life-en">{life.en}</p>
      <h2 className="lp__life-heading">
        {life.heading.map((line, i) => (
          <span key={i}>{i > 0 && <br />}{line}</span>
        ))}
      </h2>
      <div className="lp__life-video">
        <iframe
          width="560"
          height="315"
          src="https://www.youtube.com/embed/tT9TIS19HNw?si=VNDPPDM4lxEjxAKn"
          title="YouTube video player"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerPolicy="strict-origin-when-cross-origin"
          allowFullScreen
          loading="lazy"
        />
      </div>
    </section>
  );
}
